module.exports = __webpack_public_path__ + "static/img/phone1.f7a3e804.png";